import { ReactNode } from "react";
import { IMDSDialogProps } from "../dialog/dialog.types";
import { DialogTriggerProps } from "react-aria-components";
import { IMDSPopoverProps } from "@/mds/components/overlays/popover/popover.types";

export enum MDSFloatingOverlaySlotName {
  Trigger = "trigger",
  HeaderLeft = "header-left",
  HeaderContent = "header-content",
  HeaderRight = "header-right",
  Content = "content",
}

export interface IMDSFloatingOverlayProps {
  /**
   * Whether the overlay is open
   */
  isOpen?: boolean;

  /**
   * Callback when the overlay state changes
   */
  onOpenChange?: (isOpen: boolean) => void;

  /**
   * The main content of the overlay
   * Can include slotted children:
   * - header-left: Content to show on the left side of the header
   * - header-content: Main header content
   * - header-right: Content to show on the right side of the header
   */
  children: ReactNode;

  /**
   * Props for the DialogTrigger component
   */
  triggerProps?: DialogTriggerProps;

  /**
   * Props for the Dialog component
   */
  dialogProps?: IMDSDialogProps;

  /**
   * Props for the Popover component
   */
  popoverProps?: IMDSPopoverProps;
}
